import { log, process } from '@alife/tarot';
import MessageTip from '../components/message-tip';

// 接口参数白名单域名
const whiteList = ['message.alibaba.com', 'onepage.alibaba.com', 'pre-message.alibaba.com'];
// 特定接口白名单
const whiteUrl = [
    '/feedback/index.htm',
    '/template/index.htm',
    '/message/ajax/conversation/reply.htm',
    '/msgsend/ajax/postInSiteMessage.htm',
    '/msgsend/ajax/translate.htm'
];

// 是否是生产环境
let isProduction = true;
try {
    /* eslint-disable no-undef */
    if (process.env.NODE_ENV !== 'production') {
        isProduction = false;
    }
    /* eslint-enable no-undef */
} catch (e) {
    // ...
}

const puckParameter = async function (ctx, next) {
    const data = ctx.req.data;
    // 在tarot提供销毁实例的方法之前，这里先加一层判断临时处理，避免重复调用
    if (!data.params) {
      const target = document.createElement('a');
      target.href = ctx.req.url;
      const host = target.hostname || 'message.alibaba.com'; //IE下拿不到host
      ctx.req.timeout = 300000;// 设置超时30ms
      if (window.location.href.indexOf(':4080') > 0) {
        ctx.req.headers = {
          'X-Requested-With': 'puck'
        };
      }
      if (whiteList.indexOf(host) !== -1 && whiteUrl.indexOf(ctx.req.url.split('?')[0]) === -1) {
        ctx.req.data = {
          params: JSON.stringify(data)
        };
      }
    }
    await next();
};

// 接口非200单独处理白名单
const checkCodeWhiteUrl = [
    '/message/ajax/folder/folderManage.htm',
    // 联系人分组
    '/message/contact/v2/group/addGroup.htm',
    '/message/contact/detail/contactMemberInfo.htm',
    '/message/contact/v2/detail/contactCompanyInfo.htm'
];
// 超时接口白名单
const timeoutWhiteList = ['message.alibaba.com'];

//请求接口监控
const retcodeWhiteList = [
    '/message/contact/v2/listContacts.htm',
    '/message/contact/v2/detail/inquiriesList.htm',
    '/message/contact/v2/group/deleteGroup.htm',
    '/message/contact/v2/group/modifyGroup.htm',
    '/message/contact/v2/group/addGroup.htm',
    '/message/contact/v2/group/listGroups.htm',
    '/message/contact/v2/detail/contactMemberDetail.htm',
    '/message/contact/v2/detail/contactCompanyInfo.htm',
    '/message/contact/v2/detail/contactBehaviorInfo.htm',
    '/message/contact/v2/remark/contactListRemark.htm',
    '/msgsend/ajax/postInSiteMessage.htm',
    '/message/contact/v2/tag/markingTag.htm',
    '/message/contact/v2/customer/addCustomer.htm',
    '/message/contact/v2/group/assignGroup.htm'
];

const redcodeCheck = ({ res, req }) => {
    // 非线上环境不上报
    if (!isProduction) {
        return;
    }
    //接口异常
    const name = req.originUrl.split('/').pop();
    if (res.status === 200) {
        const { body } = res;
        if (parseInt(body.code) === 200) {
            window.__WPO.retCode(name, true);
        } else {
            window.__WPO.retCode(name, false, 0, body.code, body.message);
        }
    } else {
        window.__WPO.retCode(name, false, 0, res.status, res.statusText);
    }
};

const puckCodeCheck = async function (ctx, next) {
    await next();
    const ret = ctx.res.body;
    const target = document.createElement('a');
    target.href = ctx.req.url;
    const host = target.hostname || 'message.alibaba.com';
    if (ret && timeoutWhiteList.indexOf(host) !== -1 && (parseInt(ret.code) === 401 || parseInt(ret.code) === 402)) {
        const href = window.location.href;
        log('##### url timeout ######', ctx.req.url);
        // eslint-disable-next-line
        if (process.env.NODE_ENV === 'production') {
            setTimeout(() => {
                window.location.href = `//login.alibaba.com?return_url=${href}`;
            }, 500);
        }
    }

    //获取返回数据监控
    retcodeWhiteList.indexOf(ctx.req.originUrl) !== -1 && window.__WPO && redcodeCheck(ctx);

    if (parseInt(ret.code) !== 200 && checkCodeWhiteUrl.indexOf(ctx.req.url.split('?')[0]) === -1) {
        let errorMessage;
        errorMessage = `${ret.message} ( ${ret.code} )`;
        // eslint-disable-next-line
        if (process.env.NODE_ENV !== 'production') {
            errorMessage = `${ctx.req.url} - ${ret.code}`;
        }
        MessageTip.error(errorMessage);
    }
};

const puckXRequest = async function (ctx, next) {
    const oldHead = ctx.req.headers;
    ctx.req.headers = Object.assign(oldHead, {
        'x-requested-with': 'pom'
    });
    await next();
};

export default puckParameter;
export { puckCodeCheck, puckXRequest };
